<div class="input-group" style="width: 100%" aria-label="Select Lease Type">
    <select name="reportedLeaseSelect"
            [(ngModel)]="value"
            class="form-select form-select-sm exclude-modal-styling"
            (ngModelChange)="select($event)">
        @for (leaseType of values; track leaseType) {
            <option [ngValue]="leaseType.leaseTypeId">{{ leaseType.leaseTypeId }}</option>
        }
    </select>
</div>
